import { Link } from '@material-ui/core';
// eslint-disable-next-line no-restricted-imports
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@ui';
import React from 'react';
import { Loader } from '../common/Loader';
import { SearchUser, SearchUserContext, useGetManagedUsers } from '../user-management';
import { StyledLicenseUserList as LicenseUserList } from './UserList';

export const LicenseAssignmentModalContent: React.FC = () => {
  const { data: users = [], status } = useGetManagedUsers();

  const classes = useStyles();

  return (
    <SearchUserContext users={users}>
      {status === 'loading' && <Loader />}
      {status === 'success' && users.length > 0 && (
        <>
          <SearchUser />
          <LicenseUserList />
        </>
      )}
      {status === 'success' && users.length === 0 && (
        <Alert
          severity='info'
          classes={{
            message: classes.infoMessage,
            icon: classes.icon,
          }}
        >
          No users have been added yet.
          <br />
          You can invite users under the <Link href={'/account#!/users'}>User Management</Link>{' '}
          view.
        </Alert>
      )}
    </SearchUserContext>
  );
};

const useStyles = makeStyles({
  infoMessage: {
    fontSize: 16,
  },
  icon: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
});
